import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/jobs`, {params})
    },
    listRequests(params) {
        return Vue.axios.get(`/job-requests`, {params})
    },
    create(params) {
        return Vue.axios.post(`/jobs/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/jobs/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/jobs/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/jobs/${id}`)
    },
}
